module.exports = __webpack_public_path__ + "img/step-5.590ed729.jpg";